export default __webpack_public_path__ + "locales/bg/ConvertDialog.json?hash=770b5bb9d3d550f2f25471a38e416505";